import React from "react";
import styles from "./YearSeparator.module.scss";

interface YearSeparatorProps {
	year: number;
}

export const YearSeparator: React.FC<YearSeparatorProps> = ({ year }) => {
	return (
		<div className={styles.wrapper}>
			<div className={styles.line} />
			<span className={styles.year}>{year}</span>
			<div className={styles.line} />
		</div>
	);
};
